module.exports = __webpack_public_path__ + "img/left1.cf00db4e.png";